// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"g4-z","colorTextValue":"h4-z","swatches":"i4-z","collapseLink":"j4-z","isCollapsed":"k4-z","dropdown":"l4-z","disabled":"m4-z"};